<script lang="ts">
    import { signIn } from "@utils/underhood/firebase"
    import Password from "@components/material/Password.svelte"
    import ForgotPassword from "./ForgotPassword.svelte"
    import { errorize } from "@utils/underhood/firebase-errors"
    import Button from "@components/button/Button.svelte"
    import FormInput from "./FormInput.svelte"

    let email = ""
    let password = ""

    let signInPromise: ReturnType<typeof signIn> | null = null
    let signingIn = false
    let error = ""

    async function startSignIn() {
        signInPromise = signIn(email, password)
        signingIn = true
        try {
            await signInPromise
        } catch (err) {
            error = "" + err
        }
        signingIn = false
    }

    let errorMessage: string
    $: errorMessage = errorize(error)
</script>

<form class="auth-form form" on:submit|preventDefault={startSignIn} class:loading={signingIn}>
    <formgroup>
        <!-- <label>Email</label> -->
        <FormInput
            placeholder="Email address"
            type="email"
            bind:value={email}
            autocomplete="email"
        />
    </formgroup>

    <formgroup>
        <!-- <label>Password</label> -->
        <Password bind:value={password} />
    </formgroup>

    <formgroup>
        <Button type="submit" color="purple" loading={signingIn} disabled={signingIn} fullwidth>
            Log in
        </Button>
    </formgroup>
    <ForgotPassword bind:email />

    {#if errorMessage}
        <error>
            {errorMessage}
        </error>
    {/if}
</form>
